import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverExcess from './driver-excess.jsx';

export default class DriversExcesses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_excess_accounts: props.driversExcessAccountsAll || null,
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/excesses',
    };


    this.getDriversExcesses();
  }

  getDriversExcesses() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_excess_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversExcesses = [];

    if (this.state.drivers_excess_accounts &&
        this.state.drivers_excess_accounts.length > 0) {
        this.state.drivers_excess_accounts.forEach(
          function(i) {
            DriversExcesses.push(
              <DriverExcess
                key={'drivers-excesses-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversExcesses}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-excesses')) {
  ReactDOM.render(
    <DriversExcesses
      url = {"/api/v1/portal/drivers/excesses"}
      message_if_none = 'Excessses not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-excesses'
    )
  );
}
